module.exports = __webpack_public_path__ + "img/quarter-grade.fee29f86.svg";